import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo-IRC.png";
import data from "./formatted_data.json";
import "./compte.css";

const Compte = () => {
  const [userInformation, setUserInformation] = useState(null);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const email = Cookies.get("email");

  // Read base URL from .env and sanitize trailing slash
  const API_BASE = (process.env.REACT_APP_BASE_URL || "http://127.0.0.1/irc").replace(/\/$/, "");

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await axios.post(
          `${API_BASE}/Mon-compte.php`,
          { email }
        );
        setUserInformation(response.data.userInformation);
      } catch (error) {
        console.error("Error fetching user information:", error);
        setUserInformation(null); // keep "Loading..." minimal change
        setErrorMessage("Impossible de récupérer les informations utilisateur.");
      }
    };

    if (email) fetchUserInfo();
  }, [email, API_BASE]);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_BASE}/changeMotDePasse.php`,
        {
          email,
          currentPassword,
          newPassword,
        }
      );

      if (!response.data.error) {
        setErrorMessage("");
        setShowPasswordForm(false);
      } else {
        setErrorMessage(response.data.error_msg);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className="compte-container">
      <div className="compte-topbar">
        <div className="compte-topbar-logo">
          <img src={logo} alt="Logo" className="compte-logo" style={{ height: '80px', width: 'auto' }} />
        </div>
        <div className="compte-topbar-buttons">
          <Link to="/home">
            <button className="compte-btn">Home</button>
          </Link>
          <Link to="/login">
            <button className="compte-btn">Se déconnecter</button>
          </Link>
        </div>
      </div>
      <div className="compte-card">
        <h2 className="compte-title">Informations D'administrateur</h2>
        {userInformation ? (
          <div className="compte-user-info">
            <p>
              <strong>Nom :</strong> {userInformation.nom}
            </p>
            <p>
              <strong>Prénom :</strong> {userInformation.prenom}
            </p>
            {/* Ajoutez d'autres champs utilisateur si nécessaire */}
          </div>
        ) : (
          <p>Chargement...</p>
        )}
        {errorMessage && <p className="compte-error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default Compte;
